"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _UserName = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserName"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _DateTimeWithTooltip = _interopRequireDefault(require("./DateTimeWithTooltip"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Label = _interopRequireDefault(require("@insided/shared/uikit/Label"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*
Any pill added under displayPostStatusPill is available only for control (for now) so no need to add translations
Also we can consider updating this component name, since it includes more info then Author, but need to check all of it's usages first
 */
var AuthorInfo = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AuthorInfo, _Component);

  var _super = _createSuper(AuthorInfo);

  function AuthorInfo() {
    (0, _classCallCheck2.default)(this, AuthorInfo);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(AuthorInfo, [{
    key: "render",
    value: function render() {
      var _ref3;

      var _this$props = this.props,
          author = _this$props.author,
          timestamp = _this$props.timestamp,
          displayAuthor = _this$props.displayAuthor,
          isBestAnswer = _this$props.isBestAnswer,
          isReplyHighlighted = _this$props.isReplyHighlighted,
          displayPostStatusPill = _this$props.displayPostStatusPill,
          isReplyTrashed = _this$props.isReplyTrashed,
          isReplySpam = _this$props.isReplySpam,
          isReplyPending = _this$props.isReplyPending,
          isNew = _this$props.isNew,
          isReplyPinned = _this$props.isReplyPinned,
          isReplyReported = _this$props.isReplyReported;

      var _ref = author || {},
          rank = _ref.rank,
          userTitle = _ref.userTitle;

      var _ref2 = rank !== null && rank !== void 0 ? rank : {},
          rankIconUrl = _ref2.iconUrl,
          rankTitle = _ref2.name;

      var userRankTitle = (_ref3 = userTitle !== null && userTitle !== void 0 ? userTitle : rankTitle) !== null && _ref3 !== void 0 ? _ref3 : '';
      var replyTime = timestamp ? new Date(timestamp).getTime() : null;
      return (0, _preact.h)("div", {
        className: "author-info-wrapper"
      }, (0, _preact.h)("div", {
        className: "author-info"
      }, (0, _preact.h)(_UserName.default, {
        user: author,
        extraClass: "username"
      }), rankIconUrl && (0, _preact.h)("img", {
        src: (0, _absoluteUrlRuntime.resolveUrl)(rankIconUrl),
        alt: rankTitle,
        className: "rank-icon"
      }), displayAuthor && (0, _preact.h)(_Label.default, {
        label: (0, _preact.h)(_phrase.default, {
          p: "Author"
        }),
        variant: "brand"
      }), isBestAnswer && (0, _preact.h)(_Label.default, {
        label: (0, _preact.h)(_phrase.default, {
          p: "Answer"
        }),
        variant: "success"
      }), displayPostStatusPill && isReplyHighlighted && (0, _preact.h)(_Label.default, {
        label: "Highlight",
        variant: "warning"
      }), displayPostStatusPill && isReplyTrashed && (0, _preact.h)(_Label.default, {
        label: "Trashed",
        variant: "neutral"
      }), displayPostStatusPill && isReplySpam && (0, _preact.h)(_Label.default, {
        label: "Spam",
        variant: "danger"
      }), displayPostStatusPill && isReplyPending && (0, _preact.h)(_Label.default, {
        label: "Pending",
        variant: "danger"
      }), displayPostStatusPill && isNew && (0, _preact.h)(_Label.default, {
        label: "New",
        variant: "brand"
      }), displayPostStatusPill && isReplyPinned && (0, _preact.h)(_Label.default, {
        label: "Pinned",
        variant: "discovery"
      }), displayPostStatusPill && isReplyReported && (0, _preact.h)(_Label.default, {
        label: "Reported",
        variant: "danger"
      })), (0, _preact.h)("div", {
        className: (0, _classnames.default)('author-info', {
          'dot-seperated': userRankTitle && replyTime
        })
      }, userRankTitle && (0, _preact.h)("span", {
        className: "rank-title"
      }, userRankTitle), replyTime && (0, _preact.h)(_DateTimeWithTooltip.default, {
        replyTime: replyTime
      })));
    }
  }]);
  return AuthorInfo;
}(_preact.Component);

var _default = AuthorInfo;
exports.default = _default;